export type IllustrationFit = 'zoom' | 'contain';

export interface OnboardingSlideMeta {
  kind?: 'illustration' | 'theme';
  illustration?: string;
  titleKey: string;
  subtitleKey: string;
  ctaKey: string;
  illustrationScale?: number;
  illustrationFit?: IllustrationFit;
}

export const ONBOARDING_SLIDES: OnboardingSlideMeta[] = [
  {
    illustration: '/onboarding/hero-1.webp',
    titleKey: 'onboarding.slide1Title',
    subtitleKey: 'onboarding.slide1Subtitle',
    ctaKey: 'common.next',
    illustrationScale: 1.55,
    illustrationFit: 'zoom',
  },
  {
    illustration: '/onboarding/onboarding-phone.webp',
    titleKey: 'onboarding.slide2Title',
    subtitleKey: 'onboarding.slide2Subtitle',
    ctaKey: 'common.next',
    illustrationScale: 2.35,
    illustrationFit: 'zoom',
  },
  {
    illustration: '/onboarding/onboarding-window.webp',
    titleKey: 'onboarding.slide3Title',
    subtitleKey: 'onboarding.slide3Subtitle',
    ctaKey: 'common.next',
    illustrationFit: 'contain',
  },
  {
    kind: 'theme',
    titleKey: 'onboarding.themeTitle',
    subtitleKey: 'onboarding.themeSubtitle',
    ctaKey: 'common.getStarted',
  },
];

export const ONBOARDING_IMAGE_URLS = ONBOARDING_SLIDES.map((slide) => slide.illustration).filter(
  (src): src is string => Boolean(src),
);

export const SPLASH_IMAGE_URL = '/brand/logo-128.webp';
